import { render, staticRenderFns } from "./CmgBagOfferModal.vue?vue&type=template&id=8fd6c100&scoped=true&lang=pug"
import script from "./cmg-bag-offer-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-bag-offer-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgBagOfferModal.vue?vue&type=style&index=0&id=8fd6c100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd6c100",
  null
  
)

export default component.exports